import { SITEMAX_STATIC_URL } from '@smx-ui-common/consts';
import { Flex } from 'antd';
import * as React from 'react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { paths } from '../common';

type LogoTypeType = 'full' | 'short';

type LogoStyleType = {
    type?: LogoTypeType;
    size?: string;
};
type LogoProps = {
    type?: LogoTypeType;
    size?: string;
    margin?: string;
};

const LogoStyle = styled.a<LogoStyleType>`
    display: block;
    background: transparent
        url(${(props) =>
            props.type === 'full' ? `${SITEMAX_STATIC_URL}/logo-full.png` : `${SITEMAX_STATIC_URL}/logo-short.svg`})
        no-repeat 0 0;
    text-indent: -9999px;
    margin: 0 auto;
    width: ${(props) => (props.type === 'full' ? '200px' : props.size || '33px')};
    height: ${(props) => (props.type === 'full' ? '28px' : props.size || '33px')};
    //background-size: cover;
    background-position-y: bottom;
`;

export const Logo: React.FC<LogoProps> = ({ type, margin, size }) => {
    const history = useNavigate();
    const location = useLocation();

    const onClick = useCallback(() => {
        history(paths.MAIN);
    }, [location, history]);

    const logo = (
        <LogoStyle href={'#'} type={type} size={size} onClick={onClick}>
            SiteMax
        </LogoStyle>
    );

    return (
        <Flex style={{ margin: margin }} className="logo" align={'center'}>
            {type === 'full' ? (
                logo
            ) : (
                <div style={{ borderRadius: '50%', padding: 5, backgroundColor: '#08172B' }}>{logo}</div>
            )}
        </Flex>
    );
};
